import { render, staticRenderFns } from "./Past.vue?vue&type=template&id=f1311cfa&"
import script from "./Past.vue?vue&type=script&lang=ts&"
export * from "./Past.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports